const isFooterLinkModel = (model) => {
    return !!model.linkText;
};

export { isFooterLinkModel };
//# sourceMappingURL=types.js.map
